import { useState } from "react";
import { Button, IconInput, PasswordInput } from "ui";

const LoginForm = () => {
    const [email, setEmail] = useState("");
    const [pswd, setPswd] = useState("");
    const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };
    const handleChangePswd = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPswd(e.target.value);
    };
    return (
        <div className="login-form">
            <IconInput
                value={email}
                handleChange={handleChangeEmail}
                className="email-input"
                placeHolder="your.email@gmail.com"
                svg="cursor-default user"
                svgSize={18}
                svgColor="light-grey-svg"
            />
            <PasswordInput value={pswd} handleChange={handleChangePswd} />
            <div className="field">
                <div className="control">
                    <Button
                        text="Login"
                        rounded={true}
                        raised={true}
                        className="is-fullwidth"
                    />
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
